<div class="container  align-items-center">
  <!-- <div class="card card-container  "> -->
  <div class="card-header" [ngStyle]="{'background-color': onderneming?.kleur }">
  </div>
  <div class="">
    <div class="row">
      <h1 class="col-10 cardHeader card-title text-left"><strong>Bereken Opzegtermijn</strong></h1>
      <div class="col-2 text-right mt-2">
        <a class="backButton" [routerLink]="['/',onderneming.naam,'tools']">
          <i class="fa fa-arrow-left fa-2x" aria-hidden="true"></i>
        </a>
      </div>
    </div>

    <h6 class="card-subtitle mb-5 mobileTussentitel text-muted text-left">Bereken de opzegtermijn van een werknemer.</h6>
    <div class=" row ">
      <div class="col-12">

        <form [formGroup]="opzegtermijnFormGroup" (ngSubmit)="onSubmit()">

          <div class="form-row">
            <div class="form-group col-md-6 col-sm-12">
              <label class="font-weight-bold" for="datumInDienst">DATUM IN DIENST</label>
              <input type="date" #datumIndienst (blur)="checkDate(datumIndienst.value )" formControlName="datumInDienst"
                required name="datumInDienst" class=" form-control" id="datumInDienst">
              <label *ngIf="opzegtermijnFormGroup.errors && opzegtermijnFormGroup.controls.datumOntslag.touched" class="text-danger md-1">{{
                opzegtermijnFormGroup.errors?.dates}}</label>
            </div>
            <div class="form-group col-md-6 col-sm-12">

              <label class="font-weight-bold" for="datumOntslag">DATUM ONTSLAG</label>
              <input type="date" formControlName="datumOntslag" required name="datumOntslag" class="form-control"
                id="datumOntslag">
              <label *ngIf="opzegtermijnFormGroup.errors && opzegtermijnFormGroup.controls.datumOntslag.touched" class="text-danger md-1">{{
                opzegtermijnFormGroup.errors?.dates}}</label>
            </div>


            <div class="form-group col-md-6 col-sm-12">
              <label class="font-weight-bold" for="werkgever">INITIATIEFNEMER ONTSLAG</label>
              <select id="werkgever" #isWerkgever
                (change)=" this.data.isWerkgever = checkBoolean(isWerkgever.value,'Werkgever')" name="werkgever"
                class="form-control" required>
                <option>Werkgever</option>
                <option>Werknemer</option>
              </select>
            </div>

            <div *ngIf="this.data.grensdatum2014" class="form-group col-md-6 col-sm-12">
              <label class="font-weight-bold" for="bediende">TYPE WERKNEMER (OP 31/12/2013)</label>
              <select id="bediende" #isBediende
                (change)="this.data.isBediende = checkBoolean(isBediende.value,'Bediende')" name="bediende"
                class="form-control" required>
                <option>Bediende</option>
                <option>Arbeider</option>
              </select>
            </div>
            <div *ngIf="this.data.grensdatum2014 && !this.data.isBediende" class="form-group col-md-6 col-sm-12">
              <label class="font-weight-bold" for="datumOntslag">PARITAIRE COMITE (OP 31/12/2013)</label>
              <input formControlName="paritairComite" required name="paritairComite" class="form-control"
                id="paritairComite" type="text" name="example" list="lijstParitaireComites">
              <datalist id="lijstParitaireComites">
                <option *ngFor="let p of lijstParitaireComites" [value]="p.nummer">{{p.benaming}}</option>
              </datalist>

            </div>
            <div *ngIf="this.data.grensdatum2014 && this.data.isBediende" class="form-group col-md-6 col-sm-12">
              <label class="font-weight-bold" for="brutojaarloonKlasse">BRUTOJAARLOON BEDIENDE (OP 31/12/2013)</label>
              <select id="brutojaarloonKlasse" #brutojaarloonKlasse
                (change)="this.data.brutojaarloonKlasse = brutojaarloonKlasse.value" name="brutojaarloonKlasse"
                class="form-control" required>
                <option selected value="1">Minder dan € 32.254,00</option>
                <option *ngIf="!this.data.isWerkgever" value="2">Tussen € 32.254,00 en € 64.508,00</option>
                <option *ngIf="!this.data.isWerkgever" value="3">Meer dan € 64.508,00</option>
                <option *ngIf="this.data.isWerkgever" value="3">Meer dan € 32.254,00</option>
              </select>
            </div>
          </div>
          <div class="text-right">
            <button type="submit" [disabled]="!opzegtermijnFormGroup.valid"
              class="btn btn-outline-secondary mt-1">BEREKEN</button>
          </div>

        </form>
      </div>
      <div class="col-12 mobile">
        
      
        <div *ngIf="resultaat == null" class="d-flex text-center w-100 h-100 "
          style="min-width: auto; min-height: 6em;">
          <div class="card-body d-flex align-items-center ">
            <p class="placeholder text-center w-100">vul het formulier in om resultaat te krijgen.</p>
          </div>

        </div>

        <div *ngIf="resultaat != null" class=" xMargin">
          <div  class=" text-center w-100 d-flex h-100">
            <div class=" kaderResultaat col-md-12 mb-4 mt-4">
              <h5 [ngStyle]="{'color': onderneming?.kleurKnoppen }" style="font-weight: bolder;">Totale opzeg</h5>
              <h2 class="mt-4 ">{{resultaat}}</h2>
              <p *ngIf="totaalAantalWekenOpzegtermijn >= 30">Deze werknemer komt in aanmerking voor Outplacement</p>
            </div>
          </div>
          <div *ngIf="onderneming.naam == 'Besox'" class="w-100 horizontalCenter d-flex mb-3">
            <div class="  ">
              <a type="button" href="https://www.besox.be/offerte-aanvragen/" class="pt-3 pb-3 btn btn-info btnOfferte">Vraag
                offerte aan</a>

            </div>
          </div>
        </div>

      </div>


    </div>

    <div class="card-bottom col-12 mobile" [ngStyle]="{'background-color': onderneming?.kleur }"></div>
    <div class=" mt-4 row h-100">
      <p class="text-center mx-auto font-italic">
        {{dataService.onderneming?.algemeneWaarschuwing }}
      </p>
    </div>


  </div>

  <!-- </div> -->
</div>